const InputText = require("@/modules/input/components/InputText.vue").default;
import vue from "vue";
import { actions } from "../modules/activities/stores/ActivityEntryStore";

export default {
  name: "FormMixin",
  data() {
    return {
      formErrors: null,
      formData: {},
      formOptions: {},
      sending: false,
    };
  },
  components: {
    InputText,
  },
  methods: {
    async submit(Options) {
      if (this.sending) return;
      //========================================================================================
      /**                                                                                     *
       * > Options Object parameters                                                          *
       * custom: Boolean                                                                      *
       * async: Boolean                                                                       *
       * call: String | create, destroy, [customCall]                                         *
       * id: String                                                                           *
       * type: String ("auth", "activities"..)                                                *
       * action: Function                                                                     *
       * data: custom formData Object                                                         *
       *                                                                                      */
      //========================================================================================

      if (!Options) {
        console.error("No Options Object was given!");
      }

      let defined = (Variable) => {
        return Variable !== undefined;
      };

      let params;
      let custom = defined(Options.custom) ? Options.custom : false,
        async = defined(Options.async) ? Options.async : false,
        call = defined(Options.call) ? Options.call : "create",
        id = defined(Options.id) ? Options.id : null,
        type = defined(Options.type) ? Options.type : null,
        action = defined(Options.action) ? Options.action : null,
        data = defined(Options.data) ? Options.data : null;

      let response;
      let errorMessages = [];

      this.setSending(true);

      /**
       * Setting parameters for call
       */

      if (call === "update" && !custom) {
        let localParams = data ? data : this.formData;
        params = [id, null, localParams];
      } else if (id && Object.keys(this.formData).length < 1) {
        params = id;
      } else if (data) {
        params = data;
      } else {
        if (this.formData) params = this.formData;
        if (id) params.id = id;
      }

      if (custom) {
        if (async) {
          /**
           * Custom async getter call
           * e.g. this.$store.getters["users/api"].Custom.AlertAll(params)
           */
          response = await this.$store.getters[type + "/api"]["Custom"]
            [this.capitalize(call)](params)
            .catch((e) => {
              console.error(e);
              errorMessages.push(e);
            });
        } else {
          /**
           * Custom action
           * e.g. this.$store.dispatch("users/markPositive", params)
           */

          response = await this.$store
            .dispatch(type + "/" + call, params)
            .catch((e) => {
              console.error(e);
              errorMessages.push(e.response.data.data.message);
            });
        }
      } else {
        /**
         * Default async getter call
         * e.g. this.$store.getters["users/api"].Update(params)
         */

        if (call === "update") {
          response = await this.$store.getters[type + "/api"]
            [this.capitalize(call)](...params)
            .catch((e) => {
              console.error(e);
              errorMessages.push(e);
            });
        } else {
          response = await this.$store.getters[type + "/api"]
            [this.capitalize(call)](params)
            .catch((e) => {
              console.error(e);
              errorMessages.push(e);
            });
        }
      }
      this.setSending(false);

      if (!errorMessages || errorMessages.length < 1) {
        this.$emit("sent");

        if (action !== null) {
          action(response);
        }
      }
      return;
    },
    setSending(e) {
      this.sending = e;
    },
    updateForm(key, value) {
      this.$set(this.formData, key, value);
    },
  },
};
